import { useMutation } from "@tanstack/react-query";
import { client } from "./api-client";

export const useCreateBulkVOSEmployees = () =>
  useMutation({
    mutationFn: (data) =>
      client(`employees/create/bulk/employees`, {
        data,
        successMessage: "Employees in bulk have been created successfully",
      }),
  });
